import { injectGlobal } from 'styled-components';

// tslint:disable:no-var-requires

// tslint:disable-next-line:no-unused-expression
injectGlobal`

  /* This stylesheet generated by Transfonter (https://transfonter.org) on June 15, 2017 11:23 PM */

  @font-face {
    font-family: 'Avenir';
    src: url(${require('./fonts/Avenir-Black.eot')});
    src: url(${require('./fonts/Avenir-Black.eot?#iefix')}) format('embedded-opentype'),
      url(${require('./fonts/Avenir-Black.woff')}) format('woff'),
      url(${require('./fonts/Avenir-Black.ttf')}) format('truetype');
    font-weight: 900;
    font-style: normal;
  }

  @font-face {
    font-family: 'Avenir';
    src: url(${require('./fonts/AvenirNext-Italic.eot')});
    src: url(${require('./fonts/AvenirNext-Italic.eot?#iefix')}) format('embedded-opentype'),
      url(${require('./fonts/AvenirNext-Italic.woff')}) format('woff'),
      url(${require('./fonts/AvenirNext-Italic.ttf')}) format('truetype');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Avenir';
    src: url(${require('./fonts/AvenirNext-Regular.eot')});
    src: url(${require('./fonts/AvenirNext-Regular.eot?#iefix')}) format('embedded-opentype'),
      url(${require('./fonts/AvenirNext-Regular.woff')}) format('woff'),
      url(${require('./fonts/AvenirNext-Regular.ttf')}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Avenir';
    src: url(${require('./fonts/AvenirNext-DemiBold.eot')});
    src: url(${require('./fonts/AvenirNext-DemiBold.eot?#iefix')}) format('embedded-opentype'),
      url(${require('./fonts/AvenirNext-DemiBold.woff')}) format('woff'),
      url(${require('./fonts/AvenirNext-DemiBold.ttf')}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'BigCaslon';
    src: url(${require('./fonts/BigCaslon-Medium.eot')});
    src: url(${require('./fonts/BigCaslon-Medium.eot?#iefix')}) format('embedded-opentype'),
      url(${require('./fonts/BigCaslon-Medium.woff')}) format('woff'),
      url(${require('./fonts/BigCaslon-Medium.ttf')}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }


`;



// WEBPACK FOOTER //
// src/app/src/styles/fonts.s.ts